// LocationBadge.js
'use strict';
import { connect } from 'react-redux';

import LocationBadge from '../component/LocationBadge.jsx';

import fetchTranslationByKey from '../action/fetchTranslationByKey.js';

import getUserBadges from '../selector/getUserBadges.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import i18n from '../resource/i18n.js';

const mapStateToProps = (state, { userId }) => {
  const [userLocation] = getUserBadges(state, userId, 'locations');
  const locationKey = userLocation?.replace(':', '_') || '';
  return {
    locationKey,
    isLocationKeyTranslationFetched: getNetworkingData(
      state,
      ['translation', locationKey, i18n.language],
      'isFetched'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchTranslationByKey: ({ key }) =>
      dispatch(fetchTranslationByKey({ key })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationBadge);
